





















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import AppTabs from "../AppTabs.vue";
import AppTab from "../AppTab.vue";

export interface StampGroup {
  id: number;
  name: string;
  icon: string;
  stamps: Stamp[];
}

export interface Stamp {
  id: number;
  name: string;
  path: string;
  type: number;
}

@Component({
  components: { AppTabs, AppTab }
})
export default class AppChatStampList extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  stampGroups!: StampGroup[];
  @Prop() selectedStamp!: Stamp | null;

  @Prop({ default: 0 }) tab!: number;

  private get CurrentTabIdx(): number {
    return this.tab;
  }

  private set CurrentTabIdx(nv: number) {
    this.updateTab(nv);
  }

  @Emit("update:tab") private updateTab(nv: number): number {
    return nv;
  }

  @Emit()
  private sendStamp(stamp: Stamp) {
    return stamp;
  }

  @Emit()
  private updateStamp(stamp: Stamp | null) {
    return stamp;
  }

  private get Stamps() {
    if (
      this.CurrentTabIdx < 0 ||
      this.CurrentTabIdx >= this.stampGroups.length
    ) {
      return [];
    }

    const stampGroup = this.stampGroups[this.CurrentTabIdx];

    if (!stampGroup) return [];
    return stampGroup.stamps;
  }

  private get SelectedStampId() {
    if (this.selectedStamp) {
      return this.selectedStamp.id;
    }

    return -1;
  }

  private get remainderOfStampCounts() {
    // スタンプを5個並びにするので余りをスペーサで埋める
    if (this.Stamps.length % 5 === 0) {
      return 0;
    }

    return 5 - (this.Stamps.length % 5);
  }

  private selectStamp(stamp: Stamp) {
    // スタンプ選択中にもう一度選択で送信
    if (this.selectedStamp && this.selectedStamp.id === stamp.id) {
      this.sendStamp(this.selectedStamp);
      this.updateStamp(null);
      return;
    }

    this.updateStamp(stamp);
  }
}
